import PropTypes from 'prop-types';
import React from 'react';

import LabeledControl from './LabeledControl';
import TextBox from './TextBox';

function LabeledTextBox({
  label,
  value,
  onChange,
  alignRight = false,
  alignRightText = false,
  bold = false,
  underline = false,
  disabled = false,
  labelSize = '30%',
  placeholder = undefined,
  redTextBox = false,
  password = false,
  maxLength = undefined,
}:{
  label: string,
  labelSize?: string,
  value:string|null,
  placeholder?:string|undefined,
  onChange?: ((e:React.ChangeEvent<HTMLInputElement>) => void)|undefined,
  onPaste?: ((e:React.ClipboardEvent<HTMLInputElement>) =>void)|undefined,
  disabled?: boolean,
  red?: boolean,
  alignRight?: boolean,
  alignCenter?: boolean,
  onEnter?: (() => void)|undefined,
  password?: boolean,
  onTabNext?: (() => boolean)|undefined,
  onTabPrevious?: (() => boolean)|undefined,
  maxLength?: number|undefined,
  textId?: string|undefined,
  noborder?: boolean,
  underline?: boolean,
  redTextBox?: boolean,
  bold?: boolean,
  alignRightText?: boolean,
}) {
  return <LabeledControl
    bold={bold}
    label={label}
    labelSize={labelSize}
    underline={underline}
    alignRight={alignRight}
    control={<TextBox value={value} onChange={onChange} disabled={disabled} placeholder={placeholder} red={redTextBox} alignRight={alignRightText} password={password} maxLength={maxLength} />}
  />;
}

LabeledTextBox.defaultProps = {
  onChange: () => {},
  value: '',
  alignRight: false,
  bold: false,
  underline: false,
  disabled: false,
  labelSize: '30%',
  redTextBox: false,
  alignRightText: false,
  password: false,
};

LabeledTextBox.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  alignRight: PropTypes.bool.isRequired,
  bold: PropTypes.bool.isRequired,
  underline: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  labelSize: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  redTextBox: PropTypes.bool.isRequired,
  alignRightText: PropTypes.bool.isRequired,
  password: PropTypes.bool.isRequired,
  maxLength: PropTypes.number,
  onBlur: PropTypes.func,
};


export default React.memo(LabeledTextBox);
